/*
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
*/

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/lib/util/colors';

import WorldMap from './custom_icons/WorldMap.vue';
import DXF from './custom_icons/DXF.vue';

Vue.use(Vuetify)

const opts = {
    theme: {
        options: {
            customProperties: true,
        },
        dark: false,
        themes: {
            light: {
                base: '#ffffff', //background
                background: '#fafafa',
                primary: '#213e79',
                secondary: '#c0d8ed', 
                accent: '#4ea3ed',
                error: '#b71c1c',
                info: '#2196f3',
                success: '#66bb6a', 
                warning: '#f57f17'
                /*primary: '#ff8800', //selection
                secondary: '#00ff1e', // ??
                accent: '#00ff1e', // ??
                error: colors.red.darken1, // Cancel
                info: colors.green.lighten1, // ??
                success: colors.green.darken1, // Save
                warning: colors.orange.lighten1, // ??*/
            },
            dark: {
                base: '#424242', //background
                background: '#303030',
                primary: '#ff8800', //selection
                secondary: '#00ff1e', // ??
                accent: '#00ff1e', // ??
                error: colors.red.darken1, // ??
                info: colors.blue.darken1, // ??
                success: colors.green.darken1, // ??
                warning: colors.orange.darken1, // ??
            },
        }
    },
    icons: {
        values: {
            WorldMap: {
                component: WorldMap,
            },
            DXF: {
                component: DXF,
            },
        },
    },
}

export default new Vuetify(opts)
